type Listener = (...args: any[]) => void;

export class SimpleEventEmitter {
  private listeners: { [event: string]: Listener[] } = {};

  public on(event: string, listener: Listener): void {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(listener);
  }

  public emit(event: string, ...args: any[]): void {
    if (!this.listeners[event]) return;
    const listeners = [...this.listeners[event]];
    for (const listener of listeners) {
      listener(...args);
    }
  }
}
